<template>
  <div id="SmsEditDetails">
    <Layout v-if="!loading">

      <LayoutSection size="half">
        <Card :title="$t('sms.details.messageDetails')">
          <CardSection>
            <TextField
              class="input-message-text"
              :label="$t('sms.details.messageContent')"
              v-model="editingMessage"
              multiline
              :error="extraUrlError || invalidUrlError || countryOverrideError"
            />
            <!-- <pre>extraUrl: {{extraUrlError}} {{!!extraUrlError}}</pre>
            <pre>invalidUrl: {{invalidUrlError}} {{!!invalidUrlError}}</pre> -->
          </CardSection>
          <CardSection>
            <Stack distribution="equalSpacing">
              <div>{{$t('sms.details.encoding')}}: <b>{{smsInfo.encoding}}</b></div>
              <div>{{$t('sms.details.smsSegments')}}: <b>{{smsInfo.segments}}</b></div>
              <div>{{$t('sms.details.messageLength')}}: <b>{{smsInfo.messageLength}}</b></div>
              <div>{{$t('sms.details.segmentLength')}}: <b>{{smsInfo.segmentCharCount}}</b></div>
            </Stack>
            <InlineError v-if="showUnicodeMessage">{{$t('sms.overrides.unicodeMessage')}}</InlineError>
          </CardSection>
          <CardSection>
            <div class="section-title">{{$t('sms.details.descriptionOfMessageElements')}}</div>
            <div class="message-element-description">
              <div>
                {{$t('sms.details.encoding')}}: {{$t('sms.details.encodingDescription')}}
              </div>
              <div>{{$t('sms.details.smsSegments')}}: {{$t('sms.details.smsSegmentsDescription')}}</div>
              <div>{{$t('sms.details.messageLength')}}: {{$t('sms.details.messageLengthDescription')}}</div>
              <div>{{$t('sms.details.segmentLength')}}: {{$t('sms.details.segmentLengthDescription')}}</div>
            </div>
          </CardSection>
        </Card>
      </LayoutSection>

      <LayoutSection size="half">
        <Card :title="$t('sms.details.messagePreviews')">
          <CardSection>
            <div class="section-title">
              {{$t('sms.details.messageNotification')}}
            </div>
            <preview-sms-notification class="Preview" :message="messageWithUrl" :phoneNumber="phoneNumber"/>
          </CardSection>
          <CardSection>
            <div class="section-title">
              {{$t('sms.details.messageApp')}}
            </div> 
            <preview-sms-message class="Preview" :message="messageWithUrl" :phoneNumber="phoneNumber"/>
          </CardSection>
        </Card>
      </LayoutSection>

      <LayoutSection v-if="!theUser.isDemoAccount" size="full">
        <Card v-if="countryOverrides">
          <CardSection>
            <div v-html="$t('sms.override.infoMessage', { value: countryOverrides.countryName })"/>
            <List tight class="country-overrides-list">
              <ListItem v-if="countryOverrides.days.length">{{$t('sms.override.restrictedDays')}}</ListItem>
              <ListItem v-if="countryOverrides.hoursFrom || countryOverrides.hoursTo">{{$t('sms.override.restrictedHours')}}</ListItem>
              <ListItem v-if="countryOverrides.maxMessageLength">{{$t('sms.override.maxLength')}}: {{ countryOverrides.maxMessageLength }}</ListItem>
              <ListItem v-if="countryOverrides.noMessageConcatenation">{{$t('sms.override.noMessageConcatenation')}}</ListItem>
              <ListItem v-if="countryOverrides.noUnicodeSupport">{{$t('sms.override.noUnicodeSupport')}}</ListItem>
              <ListItem v-if="countryOverrides.appendToMessage">{{$t('sms.override.appendToMessageValue', { value: countryOverrides.appendToMessage })}}</ListItem>
            </List>
          </CardSection>
          <!-- <pre>{{countryOverrides}}</pre> -->
        </Card>
        <Card>
          <CardSection v-if="smsMessage.type !== 'template' && smsMessage.status === 'draft'">
            <Stack>
              <Button @click="changePage('filters')" :disabled="!!extraUrlError || !!invalidUrlError">{{$t('Save + Back')}}</Button>
              <Button @click="changePage('filters', false)">{{$t('Back')}}</Button>
              <Button type="primary" @click="changePage('scheduling')" :disabled="!!extraUrlError || !!invalidUrlError">{{$t('Save + Next')}}</Button>
            </Stack>
          </CardSection>

          <CardSection v-if="smsMessage.type === 'template'">
            <Stack v-if="smsMessage.status === 'draft'">
              <Button type="primary" :disabled="!!extraUrlError || !!invalidUrlError" @click="activateMessage">{{$t('Activate Now')}}</Button>
              <Button :disabled="!!extraUrlError || !!invalidUrlError" @click="changePage('saveTriggered')">{{$t('Save and Continue Later')}}</Button>
            </Stack>
            <Stack v-else>
              <Button type="primary" :disabled="!!extraUrlError || !!invalidUrlError" @click="changePage('saveTriggered')">{{$t('Save')}}</Button>
            </Stack>
          </CardSection>
        </Card>
      </LayoutSection>
    </Layout>
  </div>
</template>

<script>
// import SMSEditVue from './SMSEdit.vue';
import SmsUtils from '../classes/SmsUtils.class'
import PreviewSmsNotification from '../components/PreviewSmsNotification.vue'
import PreviewSmsMessage from '../components/PreviewSmsMessage.vue'

// import EmojiPicker from 'vue-emoji-picker'
import _ from 'lodash'
// import { extend as ValidateExtend } from 'vee-validate/dist/vee-validate.full'

export default {
  name: 'SmsEditDetails',
  props: {
    smsMessage: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      definition: {
        message: '',
        url: null
      },
      phoneNumber: null,
      countryOverrides: null,
      editingMessage: null,
      defCopy: null,
      loading: true,
      slashRegex: /\/\/([a-z0-9-.ßàÁâãóôþüúðæåïçèõöÿýòäœêëìíøùîûñé]+)\//gi,
      httpsRegex: /\b(https:\/\/[^\s]+)/g,
      detectUrlRegex: /(https?:\/\/)?([\w-])+\.{1}([a-z0-9-.ßàÁâãóôþüúðæåïçèõöÿýòäœêëìíøùîûñé]{2,63})([/\w-]*)*\/?\??([^#\n\r\s]*)?#?([^\n\r\s]*)/gi
    }
  },
  mounted() {
    if (this.smsMessage) {
      this.definition = {
        message: this.smsMessage.definition.message || ''
      }
      if (this.smsMessage.definition.url) {
        this.definition.url = this.smsMessage.definition.url
      }
      this.defCopy = _.cloneDeep(this.definition)
      this.editingMessage = this.definition.url ? this.definition.message.replace('{{URL}}', this.definition.url) : this.definition.message 
      Promise.all([this.api.getSmsMessagingServiceNumber(this.smsMessage.siteId), this.api.getSmsCountryOverrides(this.smsMessage.siteId)])
        .then((data) => {
          const [phoneNumber, countryOverrides] = data
          this.phoneNumber = phoneNumber
          this.countryOverrides = countryOverrides
          if (this.countryOverrides && this.countryOverrides.appendToMessage) {
            this.editingMessage = this.editingMessage.replace(`\n${this.countryOverrides.appendToMessage}`, '')
          }
          this.loading = false
        })
        .catch(this.apiCatch)
    }
  },
  computed: {
    smsInfo() {
      return SmsUtils.getSmsInfo(this.messageWithUrl, this.countryOverrides && this.countryOverrides.noUnicodeSupport)
    },
    showUnicodeMessage(){
      return this.countryOverrides && this.countryOverrides.noUnicodeSupport && SmsUtils.getEncoding(this.messageWithUrl) === 'Unicode'
    },
    extraUrlError() {
      const matches = this.editingMessage.match(this.detectUrlRegex)
      if (matches && matches.length > 1) {
        return this.$t('sms.details.extraUrlError', { value: matches.map(m => `"${m}"`).join(', ') } )
      } 
      return ''
    },
    invalidUrlError() {
      const potentialUrlMatches = this.editingMessage.match(this.detectUrlRegex)
      if (potentialUrlMatches) {
        // and the domain name must end with a slash (/)
        if (!potentialUrlMatches[0].match(this.httpsRegex) || !potentialUrlMatches[0].match(this.slashRegex)) {
          return this.$t('sms.details.invalidUrlError', { value: potentialUrlMatches[0] })
        }
      }
      return ''
    },
    countryOverrideError() {
      if (this.countryOverrides) {
        if (this.countryOverrides.maxMessageLength && this.countryOverrides.maxMessageLength < this.smsInfo.messageLength) {
          return this.$t('sms.overrides.maxLengthError')
        }
        if (this.countryOverrides.noMessageConcatenation && this.smsInfo.segments > 1) {
          return this.$t('sms.overrides.singleSmsSegmentError')
        }
      }
      return ''
    },
    messageWithUrl() {
      let str = this.editingMessage
      const url = this.getValidUrl(str)
      if (url) {
        str = str.replace(url, 'https://s.fplr.co/xxxxxxxxxx')
      }
      if (this.countryOverrides && this.countryOverrides.appendToMessage) {
        str += `\n${this.countryOverrides.appendToMessage}`
      }
      return str
    }
  },
  methods: {
    getValidUrl(str) {
      if (str.match(this.detectUrlRegex)) {
        const validHttpsRegexMatch = str.match(this.httpsRegex)
        const validSlashBool = !!str.match(this.slashRegex)
        if (validHttpsRegexMatch && validSlashBool) {
          return validHttpsRegexMatch[0]
        }
      }
      return null
    },
    setDefinition() {
      const validUrl = this.getValidUrl(this.editingMessage)
      if (validUrl) {
        this.definition.url = validUrl
        this.definition.message = this.editingMessage.replace(validUrl, '{{URL}}')
      } else {
        this.definition.message = this.editingMessage
        this.definition.url = null
      }
      if (this.countryOverrides && this.countryOverrides.appendToMessage) {
        this.definition.message += `\n${this.countryOverrides.appendToMessage}`
      }
    },
    async changePage(nextPage, forceSave = true) {
      this.setDefinition()
      if (forceSave) {
        this.$emit('update', {
          nextPage,
          definition: this.definition
        })
      } else {
        // console.log(this.definition, this.defCopy)
        if (!_.isEqual({ message: this.definition.message || '', url: this.definition.url || null },
          { message: this.defCopy.message, url: this.defCopy.url || null })) {
          const res = await this.$ui.confirm({
            title: this.$t('Unsaved Changes'),
            content: this.$t('messaging.loseChangesMessage'),
            primaryActionLabel: this.$t('Discard changes'),
            primaryActionType: 'destructive',
            secondaryActionLabel: this.$t('Continue editing')
          })
          if (!res) return;
        }
        this.$emit('goToPage', nextPage)
      }
    },
    activateMessage() {
      const self = this
      this.$ui.confirm({
        title: this.$t('Activate Message?'),
        onConfirm() {
          self.changePage('activateMessage')
        }
      })
    },
  },
  components: {
    PreviewSmsNotification,
    PreviewSmsMessage
  }
};
</script>

<style lang="scss">
#SmsEditDetails {
  .input-message-text {
    textarea {
      min-height: 100px;
    }
  }
  .message-preview-text {
    flex: 1; 
    border: 1px solid #C4CDD5;
    border-radius: 3px;
    .message-preview-text-inner {
      padding: 10px;
      white-space: pre-wrap;
    }
  }
  .message-element-description {
    font-size: 14px;
    div {
      padding-top: 7px;
    }
    div:first-of-type {
      padding-top: 0px; 
    }
  }
  .Preview {
    margin-left: auto;
    margin-right: auto;
  }
  .section-title {
    text-align: left;
    // margin-bottom: 15px;
    padding-bottom: 10px;
    // padding-top: 9px;
    font-weight: bold;
  }
  .country-overrides-list {
    padding-top: 5px;
  }
}
</style>

